import React from "react";

const LoadingSpinner = ({ message = "Carregando..." }) => {
  return (
    <div className="flex flex-col items-center justify-center py-16 gap-4" data-testid="loading-spinner">
      <div className="loading-spinner" />
      <p className="text-sm text-slate-500 animate-pulse">{message}</p>
    </div>
  );
};

export default LoadingSpinner;
